import { render, staticRenderFns } from "./exercise.vue?vue&type=template&id=467986fc&scoped=true&"
import script from "./exercise.js?vue&type=script&lang=js&"
export * from "./exercise.js?vue&type=script&lang=js&"
import style0 from "./exercise.vue?vue&type=style&index=0&id=467986fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467986fc",
  null
  
)

export default component.exports